import React, { Fragment, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

import classNames from "classnames";

import { storePlaylistLayer } from "actions/playlist.layer.action";

import { JAVASCRIPT_VOID } from "constant/config";

import SelectBox from "components/SelectBox";
import { LAYER } from "components/boards/post/vod/layer/playlist/PlaylistLayer";
import ConditionWrapper from "components/ConditionWrapper";

const AddLayer = ({ onChangeLayer, onChangeError }) => {
	const { t } = useTranslation();

	const [title, setTitle] = useState(""), // 제목 값
		[display, setDisplay] = useState("Y"), // 공개 / 비공개 세팅
		[share, setShare] = useState("Y"); // 재생목록 퍼가기 허용/비허용

	// 제목 변경
	const handleChangeTitle = useCallback(
		(event) => {
			const value = event.target.value.trimStart();
			if (value.length > 30) {
				return false;
			}

			setTitle(value);
			onChangeError(false);
		},
		[onChangeError],
	);

	// 공개 / 비공개 세팅
	const handleChangeDisplay = useCallback((value) => {
		setDisplay(value);
	}, []);

	// 재생목록 퍼가리 허용/비허용
	const handleChangeShare = useCallback((value) => {
		setShare(value);
	}, []);

	// 재생목록 추가
	const handleStorePlaylist = useCallback(async () => {
		try {
			// 재생 목록 추가
			await storePlaylistLayer(title, display, share);

			// 재생목록 리스트 레이어로 이동
			onChangeLayer(LAYER.LIST);
		} catch (error) {
			onChangeError(true);
		}
	}, [display, onChangeError, onChangeLayer, share, title]);

	// 재생목록 레이어 페이지 변경
	const handleChangeLayer = useCallback(
		(layer) => () => {
			onChangeLayer(layer);
		},
		[onChangeLayer],
	);

	return (
		<Fragment>
			{/* 제목 영역 */}
			{isMobile && <p className="pop-title">{t("새 재생목록 만들기")}</p>}
			{!isMobile && (
				<div className="pop-title">
					<h3>{t("새 재생목록 만들기")}</h3>
				</div>
			)}

			{/* 재생목록 추가 영역 */}
			<div className="pop-body">
				<div className="ListForm">
					<div className={classNames(!isMobile ? "title" : "input_wrap")}>
						<input type="text" placeholder={t("제목을 입력해주세요")} value={title} onChange={handleChangeTitle} />
						<span className="bytes">
							<em>{title.length}/</em>30
						</span>
					</div>

					<ConditionWrapper condition={!isMobile} wrapper={<div className="select" />}>
						{/* 목록 공개 / 비허용 */}
						<SelectBox
							className={isMobile ? "select_wrap" : ""}
							options={[{ value: "Y", name: t("목록 공개") }, { value: "N", name: t("목록 비공개") }]}
							value={display}
							onChange={handleChangeDisplay}
							stopPropagation={true}
						/>

						{/* 재생목록 저장 허용 / 비허용 */}
						<SelectBox
							className={isMobile ? "select_wrap" : ""}
							options={[{ value: "Y", name: t("목록 퍼가기 허용") }, { value: "N", name: t("목록 퍼가기 비허용") }]}
							value={share}
							onChange={handleChangeShare}
							stopPropagation={true}
						/>
					</ConditionWrapper>
				</div>
			</div>

			{/* 버튼 영역 */}
			<div className="pop-btn">
				{isMobile && (
					<Fragment>
						<a href={JAVASCRIPT_VOID} className="btn" onClick={handleChangeLayer(LAYER.LIST)}>
							{t("취소")}
						</a>
						<button type="button" className="btn" onClick={handleStorePlaylist}>
							<strong>{t("추가")}</strong>
						</button>
					</Fragment>
				)}
				{!isMobile && (
					<a href={JAVASCRIPT_VOID} className="btn blue" onClick={handleStorePlaylist}>
						{t("추가")}
					</a>
				)}
			</div>
		</Fragment>
	);
};

export default AddLayer;
